export default "__VITE_ASSET__B7SqyfUF__"